import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, share } from "rxjs/operators";
import { ProfileDetailsModel } from "../model/profileDetailsModel";

@Injectable()
export class ProfileService {
    constructor(private httpClient: HttpClient) { }
  getConnectedBusinessInfo(businessId: number) {
  return this.httpClient.post(`/atn/getConnectedBusinessInfo/${businessId}`, {});
}
    saveConnectedBusinessInfo(request:ProfileDetailsModel) {
        return this.httpClient.put(`/atn`, request).pipe(share());
    }
    getPayments(businessid: number) {
        return this.httpClient.post(`/stripe/GetAllPayment`, { businessid }).pipe(map((res: any) => res), share());
    }
}